<template>
  <div>
    <start-print></start-print>
    <div class="print_container">
      <div style="color:#000;width: 150px;display: inline-block;text-align: center;">
        {{printSmallOrderInfo.shopName}}
      </div>
      <div style="font-size: 12px; margin-top: 10px;">单号:{{printSmallOrderInfo.orderId}}</div>
      <div style="font-size: 12px; ">时间:{{printSmallOrderInfo.createTime}}</div>
      <span>**************************</span>
      <div>
        <span>品名</span>
        <span>数量</span>
        <span>单价</span>
        <span>金额</span>
      </div>
      <span>**************************</span>
      <div class="section2" style="font-size: 12px; ">
        <div v-for="(item,index) in printSmallOrderInfo.orderCart" :key="index">
          <span style="width: 60px;display: inline-block;">{{item.prodName}}</span>
          <span style="width: 30px;display: inline-block;text-align: center;">{{item.cartNum}}</span>
          <span style="width: 30px;display: inline-block;text-align: center;">{{item.price}}</span>
          <span style="width: 40px;display: inline-block;text-align: center;">{{item.payPrice}}</span>
          <div v-if="item.barCode" style="font-size: 11px;">商品条码:{{item.barCode}}</div>
        </div>
      </div>
      <span>**************************</span>
      <div class="section5" style="font-size: 12px; ">
        <div>
          <span style="width: 65px;display: inline-block;">总数量:{{printSmallOrderInfo.cartNumCount}}</span>
          <span style="width: 85px;display: inline-block;">支付金额:{{printSmallOrderInfo.orderPayPrice}}</span>
        </div>
        <div>
          <span style="width: 75px;display: inline-block;">优惠金额:{{printSmallOrderInfo.discountPayPrice}}</span>
        </div>
      </div>
      <div class="section5" style="font-size: 12px; margin-left: 5px;" v-if="printSmallOrderInfo.content">
        <div v-html="printSmallOrderInfo.content" style="white-space: pre-wrap;"></div>
        <div><img :src="printSmallOrderInfo.qrImg" width="100px" height="100px"></div>
      </div>
    </div>
    <end-print></end-print>
    <div id="print-btn">
      <el-button type="primary" class="float-right" @click="_printPurchaseApplyDiv">
        <i class="el-icon-check"></i>&nbsp;打印
      </el-button>
      <el-button type="primary" class="float-right margin-right" @click="_printCloudPurchaseApplyDiv">
        <i class="el-icon-check"></i>&nbsp;云打印
      </el-button>
      <el-button type="warning" class="float-right" style="margin-right:20px;" @click="_closePage">
        <i class="el-icon-close"></i>&nbsp;取消
      </el-button>
    </div>
  </div>
</template>

<script>
import { queryStoreOrderCart, orderPrinter, queryFeePrintSpec } from '@/api/goods/printSmallOrderApi'
import { getShopId } from '@/api/shop/shopApi'
import StartPrint from '@/components/goods/printSmallOrder/StartPrint'
import EndPrint from '@/components/goods/printSmallOrder/EndPrint'

export default {
  name: 'PrintSmallOrder',
  components: {
    StartPrint,
    EndPrint
  },
  data() {
    return {
      printSmallOrderInfo: {
        shopName: '',
        amount: 0.00,
        orderCart: [],
        createTime: '',
        orderId: '',
        cartNumCount: 0,
        totalPayPrice: 0.0,
        totalPrice: 0.0,
        orderPayPrice: 0.0,
        content: '',
        qrImg: '',
        autoPrint: 'N',
        discountPayPrice: 0.0
      },
      printFlag: '0',
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this.printSmallOrderInfo.orderId = this.$route.query.orderId
    this.printSmallOrderInfo.autoPrint = this.$route.query.autoPrint || 'N'
    this._loadReceipt()
    this._loadPrintSpec()
    console.log(this.printFlag)
  },
  methods: {
    async _loadReceipt() {
      try {
        const param = {
          page: 1,
          row: 100,
          orderId: this.printSmallOrderInfo.orderId,
          shopId: this.shopId
        }
        const res = await queryStoreOrderCart(param)
        const _orderCart = res.data
        this.printSmallOrderInfo.orderCart = _orderCart
        let _cartNumCount = 0
        //let _totalPayPrice = 0.0
        _orderCart.forEach(item => {
          _cartNumCount += parseFloat(item.cartNum)
        })
        this.printSmallOrderInfo.cartNumCount = _cartNumCount
        this.printSmallOrderInfo.discountPayPrice = (parseFloat(_orderCart[0].totalPrice) - parseFloat(_orderCart[0].orderPayPrice)).toFixed(2)
        this.printSmallOrderInfo.orderPayPrice = _orderCart[0].orderPayPrice
        this.printSmallOrderInfo.createTime = _orderCart[0].createTime
        
        if (this.printSmallOrderInfo.autoPrint === 'Y') {
          setTimeout(() => {
            this._printPurchaseApplyDiv()
          }, 1000)
        }
      } catch (error) {
        console.error('加载收据失败:', error)
      }
    },
    _printPurchaseApplyDiv() {
      let bdhtml = window.document.body.innerHTML
      let sprnstr = "<start-print></start-print>"
      let eprnstr = "<end-print></end-print>"
      let prnhtml = bdhtml.substr(bdhtml.indexOf(sprnstr) + sprnstr.length)
      prnhtml = prnhtml.substring(0, prnhtml.indexOf(eprnstr))
      window.document.body.innerHTML = prnhtml
      console.log(window.document.body.innerHTML)
      window.print()
      window.opener = null
      window.close()
    },
    async _printCloudPurchaseApplyDiv() {
      try {
        const _paramIn = {
          shopId: this.shopId,
          orderId: this.printSmallOrderInfo.orderId
        }
        const res = await orderPrinter(_paramIn)
        if (res.code === 0) {
          this.$message.success(res.msg)
          this.$router.go(-1)
          return
        }
        this.$message.error(res.msg)
      } catch (error) {
        console.error('云打印失败:', error)
        this.$message.error('云打印失败')
      }
    },
    async _loadPrintSpec() {
      try {
        const param = {
          page: 1,
          row: 1,
          specCd: 2020,
          shopId: this.shopId
        }
        const res = await queryFeePrintSpec(param)
        const _data = res.data
        if (_data.length > 0) {
          this.printSmallOrderInfo.content = _data[0].content
          this.printSmallOrderInfo.qrImg = _data[0].qrImg
          this.printSmallOrderInfo.shopName = _data[0].printName
        }
      } catch (error) {
        console.error('加载打印规格失败:', error)
      }
    },
    _closePage() {
      window.opener = null
      window.close()
    }
  }
}
</script>

<style scoped>
.print_container {
  width: 100%;
  padding: 10px;
}
.float-right {
  float: right;
}
.margin-right {
  margin-right: 10px;
}
</style>